export const validationInput = [
  {
    key: "groupName",
    type: "name"
  }
];
